import React from 'react';
import { TrendingUp, TrendingDown, Lightbulb } from 'lucide-react';

const PatternRecognition = ({ data = {} }) => {
  const { strengths = [], weaknesses = [], insight = null } = data;
  const hasData = strengths.length > 0 || weaknesses.length > 0 || insight;

  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4 md:p-6">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-foreground">Pattern Recognition</h3>
        <p className="text-xs text-muted-foreground mt-0.5">
          Based on analysis of your journal entries and trade performance
        </p>
      </div>

      {!hasData ? (
        <div className="flex items-center justify-center h-32">
          <p className="text-sm text-muted-foreground">
            Need 10+ trades to identify patterns.
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {/* Strengths */}
          {strengths.map((s, i) => (
            <div
              key={`s-${i}`}
              className="border-l-2 border-green-500 pl-3 py-1.5"
            >
              <div className="flex items-center gap-1.5 mb-0.5">
                <TrendingUp className="w-3.5 h-3.5 text-green-500 flex-shrink-0" />
                <span className="text-xs font-medium text-green-500">Strength</span>
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-green-500/10 text-green-500 font-medium">
                  {s.symbol}
                </span>
              </div>
              <p className="text-xs text-muted-foreground">{s.message}</p>
            </div>
          ))}

          {/* Weaknesses */}
          {weaknesses.map((w, i) => (
            <div
              key={`w-${i}`}
              className="border-l-2 border-red-500 pl-3 py-1.5"
            >
              <div className="flex items-center gap-1.5 mb-0.5">
                <TrendingDown className="w-3.5 h-3.5 text-red-500 flex-shrink-0" />
                <span className="text-xs font-medium text-red-500">Weakness</span>
                <span className="text-[10px] px-1.5 py-0.5 rounded bg-red-500/10 text-red-500 font-medium">
                  {w.symbol}
                </span>
              </div>
              <p className="text-xs text-muted-foreground">{w.message}</p>
            </div>
          ))}

          {/* Insight */}
          {insight && (
            <div className="border-l-2 border-blue-500 pl-3 py-1.5">
              <div className="flex items-center gap-1.5 mb-0.5">
                <Lightbulb className="w-3.5 h-3.5 text-blue-500 flex-shrink-0" />
                <span className="text-xs font-medium text-blue-500">Insight</span>
              </div>
              <p className="text-xs text-muted-foreground">{insight.message}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PatternRecognition;
